import { render } from "./Cfooter.vue?vue&type=template&id=1de9353a"
const script = {}

import exportComponent from "C:\\WORK\\FFSTAR3\\VUESEI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__